import {ModelApi} from '@/api/model.api.js'
import {Message} from '@/models/message.model.js'

/**
 * My channel messages API service
 */
export class MyChannelMessagesApi extends ModelApi {

  //Props
  basePath = '/api/v1/my_channels'
  itemKey = 'message'
  itemsKey = 'messages'
  ModelClass = Message

  /**
   * Query
   */
  query(channelId, params, options) {
    return super
      .query(params, options, `/${channelId}/messages`)
  }
}

//Export singleton instance
export const myChannelMessagesApi = new MyChannelMessagesApi()
